import {
  Box,
  Button,
  Stack,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { handleSuccessState } from "../../redux/slices/success";

const SuccessModal = () => {
  const successState = useSelector((state) => state.success.successState);
  const dispatch = useDispatch();
  return (
    <Dialog
      open={successState.openModal}
      onClose={() => {
        dispatch(
          handleSuccessState({
            open: false,
          })
        );
      }}
      aria-labelledby="success-dialog-title"
      aria-describedby="success-dialog-description"
      fullWidth
      maxWidth={"sm"}
      sx={{
        "& .MuiDialog-paper": {
          padding: 4,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }} id="success-dialog-title">
        {successState.success ? (
          <img src="/assets/icons/success-check.svg" width={"80px"} />
        ) : (
          <img src="/assets/icons/cancel.png" width={"80px"} />
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          color={"primary.dark"}
          id="success-dialog-description"
          sx={{ textAlign: "center", fontSize: "25px", fontWeight: 500 }}
        >
          {successState.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ textAlign: "center", justifyContent: "center" }}>
        <Button
          onClick={() => {
            dispatch(
              handleSuccessState({
                openModal: false,
              })
            );
          }}
          variant="contained"
          color="primary"
          autoFocus
          sx={{ textTransform: "capitalize" }}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessModal;
